export { decodeMessage } from './decode.js';
export { encodeMessage } from './encode.js';
export { enumeration } from './codecs/enum.js';
export { message } from './codecs/message.js';
export { createReader as reader } from './utils/reader.js';
export { createWriter as writer } from './utils/writer.js';
export class CodeError extends Error {
    code;
    constructor(message, code, options) {
        super(message, options);
        this.code = code;
    }
}
//# sourceMappingURL=index.js.map